module.exports = __webpack_public_path__ + "img/qu_rs.aaecf71.jpg";